// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__-sZBR","loaderOuter":"PageOverlayLoader_loaderOuter__35Szh"};